import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ANCHORBUTTONSLISTBLOCK_LEGACY_FIELD_ORDER = [];

const {
  anchorButtonsListBlockDescriptor: _generatedAnchorButtonsListBlockDescriptor,
  anchorButtonsListBlockBlocDefinition,
  anchorButtonsListBlockDashboardLayout,
  anchorButtonsListBlockConfig,
  anchorButtonsListBlockResolveConfig,
  anchorButtonsListBlockProperties,
} = doodBlockConfig(
  {
    name: "Anchor - Buttons list",
    componentType: 'AnchorButtonsListBlockComponent',
    category: 'content',
    description: "Anchor - Buttons list.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function anchorButtonsListBlockDescriptor(): IBlockDescriptor;
export function anchorButtonsListBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function anchorButtonsListBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedAnchorButtonsListBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedAnchorButtonsListBlockDescriptor, anchorButtonsListBlockProperties, fieldOrder);
}

export {
  anchorButtonsListBlockBlocDefinition,
  anchorButtonsListBlockDashboardLayout,
  anchorButtonsListBlockProperties,
  anchorButtonsListBlockConfig,
  anchorButtonsListBlockResolveConfig,
};

export type AnchorButtonsListBlockConfig = typeof anchorButtonsListBlockConfig;
